import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ExperiencesService } from 'src/app/experiences/experiences.service';
import { Component, OnInit, Input } from '@angular/core';
import { DVFormGroup } from 'src/app/shared/helpers/dynamic-validators/dynamic-validator';

@Component({
  selector: 'app-online-experience-basic-info',
  templateUrl: './online-experience-basic-info.component.html',
  styleUrls: ['./online-experience-basic-info.component.css']
})
export class OnlineExperienceBasicInfoComponent implements OnInit {

  @Input() experienceForm: DVFormGroup;

  multiSelectSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'value',
    textField: 'display',
    allowSearchFilter: false,
  };
  experiences: any[];

  constructor(private experiencesService: ExperiencesService) { }

  ngOnInit() {
    this.loadLocalExps();
  }

  loadLocalExps() {
    this.experiencesService.getAllOnlineExperience().subscribe(
      res => {
        this.experiences = (res.data.experiences as []).map((e: any) => {
          return {
            value: e.id,
            display: e.name
          };
        });
      }
    );
  }
}
